import { render, staticRenderFns } from "./invoiceView.vue?vue&type=template&id=39f13835&scoped=true"
import script from "./invoiceView.vue?vue&type=script&lang=js"
export * from "./invoiceView.vue?vue&type=script&lang=js"
import style0 from "./invoiceView.vue?vue&type=style&index=0&id=39f13835&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f13835",
  null
  
)

export default component.exports